export default __webpack_public_path__ + "static/media/olivine39.176a9bec.png";